<template>
    <div class="automation-email-modal">
        <TabsComponent
            :tabs="tabsConfig"
            :defaultTab="'basic'"
            @tab-change="onTabChange"
        >
            <!-- Tab: Informações Básicas -->
            <template #basic>
                <div class="tab-content">
                    <div class="form-section modal-section">
                        <h4>Status da Automação</h4>
                        <div class="row mb_20">
                            <div class="status-radio-item">
                                <sw-radio
                                    v-model="formData.active"
                                    label="Ativada"
                                    :value="true"
                                    name="automationStatus"
                                />
                            </div>
                            <div class="status-radio-item">
                                <sw-radio
                                    v-model="formData.active"
                                    label="Desativada"
                                    :value="false"
                                    name="automationStatus"
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div class="form-section modal-section">
                        <h4>Configurações Básicas</h4>
                        <div class="row mb_20">
                            <div class="grid_col_12">
                                <sw-input
                                    v-model="formData.name"
                                    label="Nome da Automação *"
                                    placeholder="Ex: Envio Mensal de Contratos"
                                />
                            </div>
                        </div>

                    </div>

                    <div class="form-section modal-section">
                        <h4>Descrição</h4>
                        <div class="row mb_20">
                            <div class="grid_col_12">
                                <sw-textarea
                                    v-model="formData.description"
                                    label="Descrição da Automação"
                                    placeholder="Descreva o objetivo desta automação..."
                                    rows="3"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <!-- Tab: Frequência -->
            <template #frequency>
                <div class="tab-content">
                    <div class="form-section modal-section">
                        <h4>Configurações de Frequência</h4>
                        <div class="row mb_20">
                            <div class="grid_col_6 grid_col_s_12">
                                <sw-select
                                    v-model="formData.frequency"
                                    label="Frequência *"
                                    :options="frequencyOptions"
                                    @change="onFrequencyChange"
                                />
                            </div>
                            <div class="grid_col_6 grid_col_s_12" v-if="showTimeConfig">
                                <sw-input
                                    v-model="formData.time"
                                    label="Horário *"
                                    :mask="['##:##']"
                                    placeholder="HH:MM"
                                    maxlength="5"
                                    icon="clock"
                                />
                            </div>
                        </div>

                        <!-- Input de Data para Uma vez e Diário -->
                        <div class="row mb_20" v-if="showDateConfig">
                            <div class="grid_col_6 grid_col_s_12">
                                <sw-input
                                    v-model="formData.date"
                                    label="Data *"
                                    date-view
                                    :min-date="new Date()"
                                    icon="calendar"
                                />
                            </div>
                        </div>

                        <!-- Configuração específica por frequência -->
                        <div class="frequency-config" v-if="formData.frequency">
                            <div v-if="formData.frequency === 'once'" class="row mb_20">
                                <div class="grid_col_12">
                                    <label class="form-label">Data e Hora da Execução</label>
                                    <small class="form-help">
                                        A automação será executada apenas uma vez na data e horário especificados
                                    </small>
                                </div>
                            </div>

                            <div v-if="formData.frequency === 'weekly'" class="row mb_20">
                                <div class="grid_col_12">
                                    <label class="form-label">Dias da Semana</label>
                                    <div class="weekdays-selector">
                                        <div
                                            v-for="day in weekdays"
                                            :key="day.value"
                                            class="weekday-item"
                                            :class="{ selected: formData.weekdays.includes(day.value) }"
                                            @click="toggleWeekday(day.value)"
                                        >
                                            {{ day.label }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-if="formData.frequency === 'monthly'" class="row mb_20">
                                <div class="grid_col_6 grid_col_s_12">
                                    <sw-select
                                        v-model="formData.monthlyType"
                                        label="Tipo de Repetição"
                                        :options="monthlyTypeOptions"
                                    />
                                </div>
                                <div class="grid_col_6 grid_col_s_12" v-if="formData.monthlyType === 'day'">
                                    <sw-input
                                        v-model="formData.monthDay"
                                        label="Dia do Mês"
                                        type="number"
                                        min="1"
                                        max="31"
                                    />
                                </div>
                            </div>

                        </div>

                        <!-- Resumo da Frequência -->
                        <div v-if="frequencySummary">
                            <AlertMessage
                                :variant="ALERT_VARIANTS.INFO"
                                title="Resumo da automação"
                                :description="frequencySummary"
                            />
                        </div>
                    </div>
                </div>
            </template>

            <!-- Tab: Arquivos -->
            <template #files>
                <div class="tab-content">
                    <div class="form-section modal-section">
                        <h4>Seleção de Arquivos</h4>

                        <!-- Seletor de Arquivos -->
                        <div class="row mb_20">
                            <div class="grid_col_12">
                                <FileSelector
                                    v-model:selected-documents="selectedDocuments"
                                    :available-documents="availableDocuments"
                                />
                            </div>
                        </div>


                    </div>
                </div>
            </template>

            <!-- Tab: Destinatários -->
            <template #recipients>
                <div class="tab-content">
                    <div class="form-section modal-section">
                        <h4>Lista de Destinatários</h4>
                        <div class="row mb_20">
                            <div class="grid_col_12">
                                <sw-tag
                                    v-model="formData.recipients"
                                    label="E-mails dos Destinatários *"
                                    placeholder="Digite um e-mail e pressione Enter"
                                    color="blue"
                                    description="Digite os e-mails dos destinatários que receberão os documentos automaticamente"
                                    :validation="recipientsValidation"
                                    @tag-added="onRecipientAdded"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <!-- Tab: E-mail -->
            <template #email>
                <div class="tab-content">
                    <div class="form-section modal-section">
                        <h4>Configurações do E-mail</h4>
                        <div class="row mb_20">
                            <div class="grid_col_12">
                                <sw-input
                                    v-model="formData.emailSubject"
                                    label="Assunto do E-mail *"
                                    placeholder="Ex: Documentos - Envio Automático"
                                />
                            </div>
                        </div>

                        <div class="row mb_20">
                            <div class="grid_col_12">
                                <QuillEditor
                                    v-model="formData.emailMessage"
                                    label="Mensagem do E-mail"
                                    placeholder="Digite sua mensagem personalizada para o e-mail..."
                                    height="200px"
                                />
                            </div>
                        </div>

                        <!-- Arquivos que serão enviados -->
                        <div class="attached-files-section" v-if="selectedFilesForDisplay.length > 0">
                            <div class="attached-files-header">
                                <sw-icon name="file-text" />
                                <span>Arquivos que serão enviados ({{ selectedFilesForDisplay.length }})</span>
                            </div>
                            <div class="attached-files-list">
                                <div
                                    v-for="file in selectedFilesForDisplay"
                                    :key="file.id"
                                    class="attached-file-item"
                                >
                                    <div class="attached-file-icon">
                                        <sw-icon name="file-text" />
                                    </div>
                                    <div class="attached-file-info">
                                        <span class="attached-file-name">{{ file.name }}</span>
                                        <div class="attached-file-details">
                                            <span class="attached-file-type">{{ file.type || 'Documento' }}</span>
                                            <span v-if="file.status === 'expiring' && file.statusLabel" class="attached-file-status status-expiring">
                                                {{ file.statusLabel }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </TabsComponent>

        <div class="modal-actions">
            <sw-button
                :name="isEditing ? 'Salvar Alterações' : 'Criar Automação'"
                color="blue"
                @click="saveAutomation"
                :disabled="!isFormValid"
            />
            <sw-button
                name="Cancelar"
                color="gray"
                @click="closeModal"
            />
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, watch, onMounted } from 'vue';
    import TabsComponent from '@Component/tabs/TabsComponent.vue';
    import FileSelector from '@Component/files/FileSelector.vue';
    import QuillEditor from '@Component/forms/QuillEditor.vue';
    import AlertMessage from '@Component/alerts/AlertMessage.vue';
    import {
        AUTOMATION_FREQUENCY_OPTIONS,
        AUTOMATION_WEEKDAYS,
        AUTOMATION_MONTHLY_TYPE_OPTIONS,
        AUTOMATION_CONFIG,
        ALERT_VARIANTS
    } from '@/constants';
    import {
        mockAutomationApi,
        mockAvailableDocuments
    } from '@/data/mockData';

    const props = defineProps({
        automationData: {
            type: Object,
            default: null
        }
    });

    const emit = defineEmits(['close', 'save']);

    const formData = ref({
        name: '',
        description: '',
        active: false,
        frequency: '',
        time: AUTOMATION_CONFIG.DEFAULT_TIME,
        date: '',
        weekdays: [],
        monthlyType: 'day',
        monthDay: 1,
        selectedDocuments: [],
        recipients: [],
        emailSubject: '',
        emailMessage: ''
    });

    const currentTab = ref('basic');

    // Estado do FileSelector
    const selectedDocuments = ref([]);
    const availableDocuments = ref([]);

    // Computed para arquivos selecionados com informações completas
    const selectedFilesForDisplay = computed(() => {
        console.log('selectedDocuments.value:', selectedDocuments.value);
        console.log('availableDocuments.value:', availableDocuments.value);

        const result = selectedDocuments.value.map(selectedId => {
            const found = availableDocuments.value.find(doc => doc.id === selectedId);
            console.log(`Looking for ID ${selectedId}, found:`, found);
            return found;
        }).filter(Boolean);

        console.log('selectedFilesForDisplay result:', result);
        return result;
    });

    // Carregar documentos disponíveis e dados de automação
    onMounted(() => {
        availableDocuments.value = mockAvailableDocuments;

        // Carregar dados da automação se estiver editando
        if (props.automationData) {
            Object.assign(formData.value, props.automationData);
            if (props.automationData.selectedDocuments) {
                selectedDocuments.value = [...props.automationData.selectedDocuments];
            }
        }
    });

    // Configuração das Tabs
    const tabsConfig = ref([
        {
            id: 'basic',
            label: 'Informações',
            icon: 'info'
        },
        {
            id: 'frequency',
            label: 'Frequência',
            icon: 'clock'
        },
        {
            id: 'files',
            label: 'Arquivos',
            icon: 'folder'
        },
        {
            id: 'recipients',
            label: 'Destinatários',
            icon: 'mail'
        },
        {
            id: 'email',
            label: 'E-mail',
            icon: 'mail2'
        }
    ]);

    // Computed
    const isEditing = computed(() => !!props.automationData);

    const showTimeConfig = computed(() => {
        return ['once', 'daily', 'weekly', 'monthly'].includes(formData.value.frequency);
    });

    const showDateConfig = computed(() => {
        return ['once', 'daily'].includes(formData.value.frequency);
    });

    const frequencySummary = computed(() => {
        if (!formData.value.frequency) return '';

        const frequency = formData.value.frequency;
        const time = formData.value.time;
        const date = formData.value.date;

        switch (frequency) {
            case 'once':
                return date && time
                    ? `Será enviado uma única vez no dia ${formatDate(date)} às ${time}`
                    : 'Selecione a data e horário para envio único';

            case 'daily':
                return date && time
                    ? `Será enviado diariamente a partir do dia ${formatDate(date)} às ${time}`
                    : 'Selecione a data de início e horário para envio diário';

            case 'weekly':
                if (formData.value.weekdays.length === 0) {
                    return 'Selecione os dias da semana para envio semanal';
                }
                const weekdayLabels = formData.value.weekdays.map(day => {
                    const weekday = weekdays.value.find(w => w.value === day);
                    return weekday?.label;
                }).filter(Boolean).join(', ');
                return time
                    ? `Será enviado semanalmente ${weekdayLabels} às ${time}`
                    : `Será enviado semanalmente ${weekdayLabels} (defina o horário)`;

            case 'monthly':
                const monthType = formData.value.monthlyType;
                const monthDay = formData.value.monthDay;

                if (monthType === 'last') {
                    return time
                        ? `Será enviado no último dia de cada mês às ${time}`
                        : 'Será enviado no último dia de cada mês (defina o horário)';
                } else {
                    return time
                        ? `Será enviado todo dia ${monthDay} do mês às ${time}`
                        : `Será enviado todo dia ${monthDay} do mês (defina o horário)`;
                }

            default:
                return '';
        }
    });

    const isFormValid = computed(() => {
        return formData.value.name &&
               formData.value.frequency &&
               selectedDocuments.value.length > 0 &&
               formData.value.recipients.length > 0 &&
               formData.value.emailSubject;
    });

    const recipientsValidation = computed(() => {
        const hasRecipients = formData.value.recipients.length > 0;
        return {
            isValid: hasRecipients,
            error: {
                message: hasRecipients ? '' : 'Adicione pelo menos um destinatário'
            }
        };
    });


    // Opções usando constantes
    const frequencyOptions = ref(AUTOMATION_FREQUENCY_OPTIONS);
    const weekdays = ref(AUTOMATION_WEEKDAYS);
    const monthlyTypeOptions = ref(AUTOMATION_MONTHLY_TYPE_OPTIONS);



    // Métodos
    const onTabChange = (tabId) => {
        currentTab.value = tabId;
    };


    const onRecipientAdded = (email) => {
        // Validar se é um email válido
        if (!isValidEmail(email)) {
            // Remove o email inválido
            const index = formData.value.recipients.indexOf(email);
            if (index > -1) {
                formData.value.recipients.splice(index, 1);
            }
        }
    };

    const closeModal = () => {
        resetForm();
        emit('close');
    };

    const resetForm = () => {
        formData.value = {
            name: '',
            description: '',
            active: false,
            frequency: '',
            time: AUTOMATION_CONFIG.DEFAULT_TIME,
            date: '',
            weekdays: [],
            monthlyType: 'day',
            monthDay: 1,
            selectedDocuments: [],
            recipients: [],
            emailSubject: '',
            emailMessage: ''
        };
        selectedDocuments.value = [];
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR');
    };

    const onFrequencyChange = () => {
        // Reset specific frequency configs
        formData.value.weekdays = [];
        formData.value.monthlyType = 'day';
        formData.value.monthDay = 1;
        formData.value.date = '';
    };


    const toggleWeekday = (day) => {
        const index = formData.value.weekdays.indexOf(day);
        if (index > -1) {
            formData.value.weekdays.splice(index, 1);
        } else {
            formData.value.weekdays.push(day);
        }
    };



    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const saveAutomation = async () => {
        if (!isFormValid.value) return;

        try {
            // Preparar dados da automação
            const automationData = {
                ...formData.value,
                id: props.automationData?.id || null,
                selectedDocuments: selectedDocuments.value,
                createdAt: props.automationData?.createdAt || new Date().toISOString(),
                updatedAt: new Date().toISOString()
            };

            // Usar mock API
            const response = await mockAutomationApi.saveAutomation(automationData);

            if (response.success) {
                console.log('Automação salva:', response.data);
                emit('save', response.data);
            }
        } catch (error) {
            console.error('Erro ao salvar automação:', error.message);
            // Aqui você poderia mostrar uma notificação de erro
        }
    };


    // Sincronizar selectedDocuments com formData
    watch(selectedDocuments, (newSelection) => {
        formData.value.selectedDocuments = [...newSelection];
    }, { deep: true });


</script>

<style lang="scss" scoped>
    @import '@/assets/css/mediaScreen.scss';

    .automation-email-modal {
        .tab-content {
            min-height: 300px;
            padding: 1em 0;
        }


        .frequency-config {
            .weekdays-selector {
                display: flex;
                gap: 0.5em;
                flex-wrap: wrap;

                .weekday-item {
                    padding: 0.5em 0.75em;
                    border: 1px solid var(--borderColorLight);
                    border-radius: 0.5em;
                    cursor: pointer;
                    font-size: 0.875em;
                    font-weight: 500;
                    transition: all 0.2s ease;

                    &:hover {
                        border-color: var(--linkColor);
                        background: rgba(59, 130, 246, 0.05);
                    }

                    &.selected {
                        background: var(--linkColor);
                        color: white;
                        border-color: var(--linkColor);
                    }
                }
            }
        }

        // Arquivos anexados
        .attached-files-section {
            margin-top: 1.5em;
            padding: 1em;
            background: rgba(59, 130, 246, 0.02);
            border: 1px solid rgba(59, 130, 246, 0.1);
            border-radius: 0.5em;
        }

        .attached-files-header {
            display: flex;
            align-items: center;
            gap: 0.5em;
            margin-bottom: 0.75em;
            font-size: 0.875em;
            font-weight: 600;
            color: var(--colorBlue);

            .sw-icon {
                font-size: 1.125em;
            }
        }

        .attached-files-list {
            display: flex;
            flex-direction: column;
            gap: 0.5em;
        }

        .attached-file-item {
            display: flex;
            align-items: center;
            gap: 0.75em;
            padding: 0.75em;
            background: white;
            border: 1px solid rgba(0, 0, 0, 0.06);
            border-radius: 0.375em;
            transition: all 0.2s ease;

            &:hover {
                border-color: rgba(59, 130, 246, 0.2);
                box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
            }
        }

        .attached-file-icon {
            width: 2em;
            height: 2em;
            background: rgba(59, 130, 246, 0.1);
            border-radius: 0.375em;
            display: flex;
            align-items: center;
            justify-content: center;
            color: var(--colorBlue);
            font-size: 0.875em;
            flex-shrink: 0;
        }

        .attached-file-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 0.25em;
        }

        .attached-file-name {
            font-size: 0.875em;
            font-weight: 600;
            color: var(--textPrimary);
            line-height: 1.2;
        }

        .attached-file-details {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 0.5em;
        }

        .attached-file-type {
            font-size: 0.75em;
            color: var(--textSecondary);
            font-weight: 500;
        }

        .attached-file-status {
            font-size: 0.6875em;
            padding: 0.125em 0.375em;
            border-radius: 0.25em;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.025em;

            &.status-active {
                background: rgba(16, 185, 129, 0.1);
                color: #10b981;
            }

            &.status-expiring {
                background: rgba(245, 158, 11, 0.1);
                color: #f59e0b;
            }

            &.status-expired {
                background: rgba(239, 68, 68, 0.1);
                color: #ef4444;
            }
        }

        // Status da automação
        .status-radio-item {
            flex: 0 0 auto;
            margin-right: 2em;
        }

        .modal-form {
            margin-bottom: 2em;

            .file-preview {
                margin-top: 1em;

                .preview-list {
                    max-height: 200px;
                    overflow-y: auto;
                    border: 1px solid var(--borderColorLight);
                    border-radius: 0.5em;
                    padding: 1em;

                    .preview-item {
                        display: flex;
                        align-items: center;
                        gap: 0.5em;
                        padding: 0.5em 0;
                        border-bottom: 1px solid var(--borderColorLight);

                        &:last-child {
                            border-bottom: none;
                        }

                        .sw-icon {
                            color: var(--linkColor);
                            width: 1em;
                            height: 1em;
                        }

                        span {
                            font-size: 0.875em;

                            &.file-type {
                                color: var(--textSecondary);
                                margin-left: auto;
                            }
                        }
                    }
                }
            }


            .form-label {
                display: block;
                font-size: 0.875em;
                font-weight: 500;
                color: var(--textPrimary);
                margin-bottom: 0.5em;
            }

            .form-help {
                display: block;
                font-size: 0.75em;
                color: var(--textSecondary);
                margin-top: 0.25em;
            }
        }

        .modal-actions {
            display: flex;
            gap: 1em;
            justify-content: flex-end;
            padding-top: 1.5em;
            border-top: 1px solid var(--borderColorLight);
        }
    }

    @include screen_medias(s) {
        .automation-email-modal {
            .modal-form .frequency-config .weekdays-selector {
                grid-template-columns: repeat(4, 1fr);
            }

            .modal-actions {
                flex-direction: column;
            }
        }
    }

    .frequency-summary {
        margin-top: 1.5em;

        .summary-card {
            background: rgba(59, 130, 246, 0.05);
            border: 1px solid rgba(59, 130, 246, 0.2);
            border-radius: 0.75em;
            padding: 1em;
            display: flex;
            align-items: flex-start;
            gap: 0.75em;

            .summary-icon {
                color: var(--linkColor);
                margin-top: 0.125em;

                .sw-icon {
                    width: 1.125em;
                    height: 1.125em;
                }
            }

            .summary-content {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 0.25em;

                .summary-label {
                    font-size: 0.875em;
                    font-weight: 600;
                    color: var(--textPrimary);
                }

                .summary-text {
                    font-size: 0.875em;
                    color: var(--textSecondary);
                    line-height: 1.4;
                }
            }
        }
    }

    // Lista de arquivos filtrados
    .files-list {
        border: 1px solid var(--borderColorLight);
        border-radius: 0.75em;
        max-height: 400px;
        overflow-y: auto;

        .file-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 1em;
            border-bottom: 1px solid var(--borderColorLight);
            cursor: pointer;
            transition: all 0.2s ease;

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                background: rgba(59, 130, 246, 0.05);
            }

            &.selected {
                background: rgba(59, 130, 246, 0.1);
                border-left: 3px solid var(--linkColor);
            }

            .file-info {
                display: flex;
                align-items: center;
                gap: 0.75em;
                flex: 1;

                .file-icon {
                    color: var(--linkColor);
                    width: 1.25em;
                    height: 1.25em;
                }

                .file-details {
                    display: flex;
                    flex-direction: column;
                    gap: 0.25em;

                    .file-name {
                        font-size: 0.875em;
                        font-weight: 500;
                        color: var(--textPrimary);
                    }

                    .file-meta {
                        font-size: 0.75em;
                        color: var(--textSecondary);
                    }
                }
            }

            .file-checkbox {
                .sw-icon {
                    color: var(--linkColor);
                    width: 1.125em;
                    height: 1.125em;
                }
            }
        }
    }

    // Mensagem de nenhum arquivo encontrado
    .no-files-message {
        text-align: center;
        padding: 3em 1em;
        color: var(--textSecondary);

        .sw-icon {
            width: 3em;
            height: 3em;
            color: var(--textLight);
            margin-bottom: 1em;
        }

        p {
            margin: 0 0 1.5em 0;
            font-size: 0.875em;
        }
    }
</style>